@if (activeVariable) {
  <form [formGroup]="activeVariable.variable" class="variable-form__container">
    <mat-card class="variable-form__card">
      <mat-card-title>
        <div class="title">
          <div class="eiq-id-badge">
            <span>{{ activeVariable.variable.value.id }}</span>
          </div>
          <span class="fs__md fw__500">{{ activeVariable.variable.value.variableToken }}</span>
        </div>
        <div class="actions">
          @if (canComment()) {
            <button mat-icon-button title="Add comment" class="settings-btn" (click)="onAddNewComment()">
              <fa-icon [icon]="faCommentPlus"></fa-icon>
            </button>
          }
        </div>
      </mat-card-title>

      <mat-card-content>
        <div class="variable-form__common">
          <div class="editor-question-form__input">
            <span class="label fs__md">Question</span>
            <empathy-text-editor
              [id]="activeVariable.variable.value.id + '_title'"
              [control]="activeVariable.variable.get('title')"
              [settings]="inputSettings"
            ></empathy-text-editor>
          </div>

          <div class="editor-question-form__input">
            <span class="label fs__md">Add Notes: <span class="fs__xs caption">(Optional)</span></span>
            <mat-form-field appearance="outline">
              <input matInput formControlName="description" autocomplete="off" />
            </mat-form-field>
          </div>
        </div>

        @if (activeVariable.variable.value.type === questionType.SingleChoice) {
          <mat-divider></mat-divider>
          <empathy-variable-choices-form [options]="activeVariable.variable.get('options') | toFormArray"></empathy-variable-choices-form>
        }
      </mat-card-content>
    </mat-card>
  </form>
}
